import { CoreDomainSearchBackend } from '@wix/core-domain-search';
import { CoreDomainSearchStore } from '@wix/domains-search-suite';
import { useCallback } from 'react';
import { DomainSearchGateModule } from '../module/domainSearchGate.module';
import { withTld } from '../utils/tldQuery';
import { useIsGateTldChipsEnabled } from './useIsGateTldChipsEnabled';
export const TLDS_LIMIT = 6;
export const useFilterableTlds = function (enabled) {
  if (enabled === void 0) {
    enabled = true;
  }
  const {
    data
  } = CoreDomainSearchBackend.hooks.useGetTldSelectorData({
    limit: TLDS_LIMIT
  }, enabled, {
    cacheTime: Infinity,
    staleTime: Infinity,
    useErrorBoundary: false,
    suspense: false,
    retry: false
  });
  return ((data == null ? void 0 : data.tldSelectorData) ?? []).map(_ref => {
    let {
      tld
    } = _ref;
    return tld;
  });
};
export const useTldPress = function (scrollBack) {
  if (scrollBack === void 0) {
    scrollBack = false;
  }
  const selectedTlds = CoreDomainSearchStore.useTlds();
  const storeQuery = CoreDomainSearchStore.useQuery();
  const inputRef = CoreDomainSearchStore.useInputRef();
  const filterable = useFilterableTlds(useIsGateTldChipsEnabled());
  const filterableKey = filterable.join(',');
  return useCallback((tld, bi) => {
    var _inputRef$input;
    const query = ((inputRef == null || (_inputRef$input = inputRef.input) == null ? void 0 : _inputRef$input.value) ?? storeQuery).trim();
    const domain = withTld(query, tld, [...selectedTlds, ...filterable]);
    DomainSearchGateModule.internals.bi.onGateTldClick == null || DomainSearchGateModule.internals.bi.onGateTldClick({
      ...bi,
      tld,
      domain,
      isSearchExecuted: false
    });
    const input = inputRef == null ? void 0 : inputRef.input;
    if (input) {
      input.value = domain;
    }
    CoreDomainSearchStore.setQuery(domain);
    CoreDomainSearchStore.setTlds(filterable.includes(tld) ? [tld] : []);
    inputRef == null || inputRef.focus();
    if (scrollBack) {
      input == null || input.scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      });
    }
    return domain;
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps -- keyed on the lists' contents
  [inputRef, storeQuery, selectedTlds, filterableKey, scrollBack]);
};
//# sourceMappingURL=useTldPress.js.map